import {Dayjs} from 'dayjs';

export type DateRangeSelectionAction = 'reset-start' | 'set-end' | 'extend-end';

export const getDateRangeSelectionAction = (
  startDate: Dayjs | null,
  endDate: Dayjs | null,
  newValue: Dayjs
): DateRangeSelectionAction => {
  if (!startDate || newValue.isBefore(startDate, 'day')) {
    return 'reset-start';
  }

  if (!endDate) {
    return 'set-end';
  }

  if (newValue.isAfter(endDate, 'day')) {
    return 'extend-end';
  }

  return 'reset-start';
};
